import { render, staticRenderFns } from "./dialogProtcolImport.vue?vue&type=template&id=255a1e3f&"
import script from "./dialogProtcolImport.vue?vue&type=script&lang=js&"
export * from "./dialogProtcolImport.vue?vue&type=script&lang=js&"
import style0 from "./dialogProtcolImport.vue?vue&type=style&index=0&id=255a1e3f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports